import Vue from 'vue'
import Vuex from 'vuex'
import GlobalModule from './Global'
import CountriesModule from './Countries'
import SlidersModule from './Sliders'
import AdministratorsModule from './Administrators'
import NoticesModule from './Notices'
import TutorialsModule from './Tutorials'
import TournamentsModule from './Tournaments'
import UsersOnline from './UsersOnline'
import DivisionModule from './Division'
import Team from './Team'
import Player from './Players'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global: GlobalModule,
    countries: CountriesModule,
    sliders: SlidersModule,
    administrators: AdministratorsModule,
    notices: NoticesModule,
    tutorials: TutorialsModule,
    tournaments: TournamentsModule,
    usersOnline: UsersOnline,
    division: DivisionModule,
    team: Team,
    player: Player
  }
})
